/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    } 
*/
export default {
  /**查询菜单树 */
  GET_LIST_API: '/maindata/menu/listMenus',
  /**新增菜单 */
  ADD_MENU_API: '/maindata/menu/insertMenu',
  /**修改菜单 */
  UPDATE_MNEU_API: '/maindata/menu/updateMenu',
  /**删除菜单 */
  DELETE_MENU_API: '/maindata/menu/deleteMenu',
  /**查询按钮 */
  GET_BTN_LIST_API: '/maindata/menuBtn/listMenuBtnTree',
  /**新增菜单按钮 */
  ADD_MENU_BTN_API: '/maindata/menuBtn/insertMenuBtn',
  /**更新菜单按钮 */
  UPDATE_MENU_BTN_API: '/maindata/menuBtn/updateMenuBtn',
  /**删除按钮 */
  DELETE_MENU_BTN_API: '/maindata/menuBtn/deleteMenuBtn',
};
